import script from "./addon.vue?vue&type=script&lang=jsx"
export * from "./addon.vue?vue&type=script&lang=jsx"

const __exports__ = script;

export default __exports__